import { getField, updateField } from 'vuex-map-fields';
import VehicleService from '../../services/VehicleService';

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = () => ({
    EndDate: null,
    HasDriversLicenseHtml: null,
    HasRentalPickUpFormHtml: null,
    HasRentalReturnFormHtml: null,
    HasTransferHtml: null,
    Id: null,
    ReportTransferId: null,
    Profile: null,
    ProfileId: null,
    ContractOwner: null,
    ContractOwnerId: null,
    StartDate: null,
    UpdateDate: null,
    CreateDate: null,
    UpdatingUserName: null,
});

const getters = {
    getField,
};

const mutations = {
    setVirtualContract(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadVirtualContract({ commit }, data) {
        const res = await VehicleService.getVirtualContract(data.id);
        commit('setVirtualContract', res.data);
        return res.data;
    },
    async loadVirtualContractAdmin({ commit }, data) {
        const res = await VehicleService.getVirtualContractAdmin(data.id);
        commit('setVirtualContract', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
